/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { defineMessages, useIntl } from 'react-intl'

import { EuiButtonIcon, EuiPopover, EuiText } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import { useToggle } from '@modules/utils/hooks/useToggle'
import { DocLink } from '@modules/doclinks'

const messages = defineMessages({
  tiebreaker: {
    id: 'tiebreaker-info-button.aria-label',
    defaultMessage: 'Learn more about tiebreakers',
  },
})

const TiebreakerInfo = () => {
  const { formatMessage } = useIntl()

  const [isPopoverOpen, togglePopover, setPopoverOpen] = useToggle()

  return (
    <EuiPopover
      button={
        <EuiButtonIcon
          onClick={togglePopover}
          color='text'
          iconType='info'
          aria-label={formatMessage(messages.tiebreaker)}
        />
      }
      isOpen={isPopoverOpen}
      closePopover={() => setPopoverOpen(false)}
    >
      <EuiText css={{ maxWidth: '300px' }} size='s'>
        <FormattedMessage
          id='tiebreaker.tiebreaker-icon-info'
          defaultMessage='We automatically include a single tiebreaker node for your deployment to help prevent a split-brain situation during master elections. {learnMore}'
          values={{
            learnMore: (
              <DocLink link='resilientClusters'>
                <FormattedMessage
                  id='tiebreaker.tiebreaker-icon-info.learn-more'
                  defaultMessage='Learn more'
                />
              </DocLink>
            ),
          }}
        />
      </EuiText>
    </EuiPopover>
  )
}

export default TiebreakerInfo
